import { InjectionToken } from '@angular/core';
import type { ApiError } from '../models/api-error.models';

/** Shows a server fault (5xx) to the user; the one caller is the HTTP interceptor. */
export interface ServerFaultPresenter {
  show(fault: ApiError): void;
}

/**
 * Runtime handle on ServerFaultService for the interceptor (WAP-1965): the service
 * opens a sui dialog, so a class import would pull the dialog layer into the
 * interceptor's module graph. Provided in app.config with `useExisting`.
 */
export const SERVER_FAULT_PRESENTER = new InjectionToken<ServerFaultPresenter>(
  'ServerFaultPresenter',
);
